module.exports = __webpack_public_path__ + "static/media/success(16) (Custom).f284a346.png";